import { Grid } from '@fortune-ui'
import { Image } from '@pets-ui/Image/Image'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import * as stylex from '@stylexjs/stylex'
import ProductAlt from '../assets/image/product-alt.svg?react'

const styles = stylex.create({
  img: (height: number) => ({
    objectFit: 'cover',
    height,
  }),
})

interface OrderThumbnailProps {
  images: string[]
}

const DESKTOP_BASE_SIZE = 38
const MOBILE_BASE_SIZE = 58

export function OrderThumbnail({ images }: OrderThumbnailProps) {
  const baseSize = useResponsive('wordPressTablet') ? DESKTOP_BASE_SIZE : MOBILE_BASE_SIZE
  if (images.length === 1) {
    return <Image src={images[0]} fallback={<ProductAlt width={baseSize * 2} />} alt="product" />
  }
  if (images.length === 2) {
    return (
      <Grid container>
        <Grid item xs={6}><Image src={images[0]} fallback={<ProductAlt width={baseSize * 2} height={baseSize * 2} />} {...stylex.props(styles.img(baseSize * 2))} alt="product" /></Grid>
        <Grid item xs={6}><Image src={images[1]} fallback={<ProductAlt width={baseSize * 2} height={baseSize * 2} />} {...stylex.props(styles.img(baseSize * 2))} alt="product" /></Grid>
      </Grid>
    )
  }
  if (images.length === 3) {
    return (
      <Grid container direction="row">
        <Grid item xs={6}><Image src={images[0]} fallback={<ProductAlt width={baseSize} height={baseSize * 2} />} {...stylex.props(styles.img(baseSize * 2))} alt="product" /></Grid>
        <Grid container item xs={6} direction="column">
          <Image src={images[1]} fallback={<ProductAlt width={baseSize} />} {...stylex.props(styles.img(baseSize))} alt="product" />
          <Image src={images[2]} fallback={<ProductAlt width={baseSize} />} {...stylex.props(styles.img(baseSize))} alt="product" />
        </Grid>
      </Grid>
    )
  }
  if (images.length === 4) {
    return (
      <Grid container>
        <Image src={images[0]} fallback={<ProductAlt width={baseSize} />} {...stylex.props(styles.img(baseSize))} alt="product" />
        <Image src={images[1]} fallback={<ProductAlt width={baseSize} />} {...stylex.props(styles.img(baseSize))} alt="product" />
        <Image src={images[2]} fallback={<ProductAlt width={baseSize} />} {...stylex.props(styles.img(baseSize))} alt="product" />
        <Image src={images[3]} fallback={<ProductAlt width={baseSize} />} {...stylex.props(styles.img(baseSize))} alt="product" />
      </Grid>
    )
  }

  return <Image src={undefined} fallback={<ProductAlt width={baseSize * 2} />} alt="product" />
}
